import { configureStore } from '@reduxjs/toolkit';

import appReducer from '../slices/appSlice';
import matrixReducer from '../slices/matrixSlice';
import instancesReducer from '../slices/instanceSlice';
import sharedReducer from '../slices/sharedSlice';
import shopIdentityReducer from '../slices/shopIdentitySlice';

const getStore = (preloadedState = {}) => {
  return configureStore({
    reducer: {
      instances: instancesReducer,
      app: appReducer,
      matrix: matrixReducer,
      shared: sharedReducer,
      shopIdentity: shopIdentityReducer,
    },
    preloadedState,
  })
};

export default getStore;
